/** Message affiché quand l'API ne répond pas du tout (coupure, DNS, CORS). */
export const MESSAGE_SERVEUR_INJOIGNABLE = 'Serveur injoignable. Vérifiez votre connexion et réessayez.';

/**
 * `fetch` relu à chaque appel (remplaçable en test) ; une panne réseau devient
 * une erreur au message français plutôt que « Failed to fetch ».
 */
export async function fetchApi(requete: Request): Promise<Response> {
  try {
    return await globalThis.fetch(requete);
  } catch {
    throw new Error(MESSAGE_SERVEUR_INJOIGNABLE);
  }
}
